import {FormControlLabel, Radio, RadioGroup} from "@mui/material";
import * as React from "react";

export default function StaffVetRegistrationsShowFilters({view, setView, newName, approved, success}) {

    let labelNew = "New registrations (" + newName + ")";
    let labelApproved = "Approved and finance pending (" + approved + ")";
    let labelSuccess = "Completed (" + success + ")";

    return (
        <div className={"stepper-box"} style={{margin: '20px 0'}}>
            <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
            >
                <FormControlLabel value="new" onChange={(e) => setView('new')}
                                  control={<Radio checked={(view === 'new')}/>} label={labelNew}/>
                <FormControlLabel value="error" onChange={(e) => setView('approved')}
                                  control={<Radio checked={(view === 'approved')}/>} label={labelApproved}/>
                <FormControlLabel value="success" onChange={(e) => setView('success')}
                                  control={<Radio checked={(view === 'success')}/>} label={labelSuccess}/>
            </RadioGroup>
        </div>
    )
}
